module.exports = __webpack_public_path__ + "img/shutterstock_10.0f672834.jpg";